import { Box, Grid, Stack, useTheme } from "@mui/material"
import PaperBox from "components/PaperBox"
import LoadingTypography from "components/skeleton/LoadingTypography"

const LoadingPage = () => {
  const numberOfSkeletonItems = [1, 2, 3, 4, 5, 6, 7]
  const theme = useTheme()

  return (
    <Box>
      <LoadingTypography height={50} variant="h1" />
      <LoadingTypography height={30} variant="caption" />
      <PaperBox>
        {numberOfSkeletonItems.map((item) => {
          return (
            <Box gap="2px" mb={2} borderBottom={1} px={2} borderColor={(theme.palette as any).default.light}>
              <Grid
                container
                direction="row"
                alignItems="center"
                paddingBottom={1}
                spacing={0}
                justifyContent="space-between"
                style={{ color: "inherit", textDecoration: "inherit" }}>
                <Grid item xs={12} md={4} lg={5}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <LoadingTypography variant="bodyMedium" />
                  </Stack>
                </Grid>

                <Grid item xs={4} md={3} lg={2}>
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <LoadingTypography variant="bodyMedium" />
                  </Stack>
                </Grid>
                <Grid item xs={4} sm={2}>
                  <LoadingTypography variant="bodyMedium" />
                </Grid>
              </Grid>
            </Box>
          )
        })}
      </PaperBox>
    </Box>
  )
}
export default LoadingPage
